module.exports = __webpack_public_path__ + "static/img/80060F_1_C_20230802_LC.dca00d9.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/raw_data/images/80060F_1_C_20230802_LC.png
// module id = P7cj
// module chunks = 0